<template>
    <section class="form-section">

            <label class="form-section-heading">
                {{ trans('clients.label.license_plan') }}
            </label>

            <div class="form-row">
                <div class="form-row__col">
                    <radiobutton-wrapper name="license_plan" v-if="!clientExists">
                        <radiobutton-card
                            v-for="(card, index) in radiobuttons"
                            :key="index"
                            :card="card"
                            :error="validate('license_plan')"
                            name="license_plan"
                        >
                        </radiobutton-card>
                    </radiobutton-wrapper>
                    <span class="invalid-feedback" v-if="validate('license_plan')">
                        <strong>{{ validate('license_plan') }}</strong>
                    </span>
                </div>
            </div>

            <div class="form-row" v-if="fields.licensePlan == 'license_plan_alpha' && !clientExists">
                <div class="form-row__col">
                    <checkbox
                        name="can_buy_licenses"
                        v-model="fields.canBuyLicenses"
                    >

                        {{ trans('clients.label.can_buy_licenses') }}
                    </checkbox>
                </div>
            </div>

            <div class="form-row" v-if="fields.licensePlan == 'license_plan_alpha' && !clientExists">
                <div class="form-row__col">
                    <form-input
                        name="expiration_period"
                        :required="true"
                        type="number"
                        min="1"
                        step="1"
                        v-model="fields.expirationPeriod"
                        :error="validate('expiration_period')"
                    >
                        {{ trans('clients.label.license_expiration_period') }}
                    </form-input>
                </div>
                <div class="form-row__col">
                    <form-input
                        name="license_amount"
                        :required="true"
                        type="number"
                        min="0"
                        step="1"
                        v-model="fields.licenseAmount"
                        :error="validate('license_amount')"
                    >
                        {{ trans('clients.label.license_amount') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row" v-if="fields.licensePlan == 'license_plan_alpha' && !clientExists && fields.licenseAmount > 0" >
                <div class="form-row__col form-row__col--one-half">
                    <label class="label" for="repeat">
                        {{ trans('clients.label.repeat_booking') }}
                    </label>
                    <select name="repeat" :class="['form-select', {'form-select--error': validate('repeat')}]" v-model="fields.repeat" id="repeat">
                        <option :value="1">{{ trans('form.yes') }}</option>
                        <option :value="0">{{ trans('form.no') }}</option>
                    </select>
                    <span class="invalid-feedback" v-if="validate('repeat')">
                        <strong>{{ validate('repeat') }}</strong>
                    </span>
                </div>

                <div class="form-row__col form-row__col--one-half" v-if="fields.repeat == '1' && fields.licenseAmount > 0">
                    <form-input
                        name="repeat_period"
                        :required="true"
                        type="number"
                        min="1"
                        step="1"
                        v-model="fields.repeatPeriod"
                        :error="validate('repeat_period')"
                    >
                        {{ trans('clients.label.repeat_period') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row" v-if="fields.licensePlan == 'license_plan_beta' && !clientExists">
                <div class="form-row__col">
                    <label class="label" for="accounting_period">{{ trans('licenses.label.accounting_period') }}</label>
                    <select name="accounting_period" v-model="fields.accountingPeriod" :class="['form-select', {'form-select--error': validate('accounting_period')}]">
                        <option value="1">{{ trans('licenses.label.monthly') }}</option>
                        <option value="3">{{ trans('licenses.label.quarterly') }}</option>
                    </select>
                    <span class="invalid-feedback" v-if="validate('accounting_period')">
                        <strong>{{ validate('accounting_period') }}</strong>
                    </span>
                </div>
                <div class="form-row__col">
                    <form-input
                        name="accounting_email"
                        :required="true"
                        type="email"
                        v-model="fields.accountingEmail"
                        :error="validate('accounting_email')"
                    >
                        {{ trans('clients.label.accounting_email') }}
                    </form-input>
                </div>
            </div>

        </section>
</template>

<script>
import { EventBus } from '../eventbus';

export default {
    model: {
        prop: 'clientLicenseFields',
        event: 'bubbleClientLicenseFields',
    },
    props: {
        'client' : {
            type: Object,
            default: () => { return {} }
        },
        'parent_id' : {
            type: Number,
        },
        formerrors: {
            type: Object,
            default: () => { return {}; },
        },
        'canCreateClientAdmin' : {
            type: Boolean
        },
        'isAdmin': {
            type: Boolean,
            default: false,
        },
        'tenantIdent': {
            type: String
        },
    },

    data() {
        return {
            fields: {
                licensePlan: this.old('license_plan', this.client.license_plan),
                canBuyLicenses: !!this.old('can_buy_licenses', this.client.can_buy_licenses),
                expirationPeriod: this.old('expiration_period', this.client.expiration_period || 2),
                licenseAmount: this.old('license_amount', this.client.license_amount || 0),
                repeat: this.old('repeat', 1),
                repeatPeriod: this.old('repeat_period', 12),
                accountingPeriod: this.old('accounting_period', this.client.accounting_period || 1),
                accountingEmail: this.old('accounting_email', this.client.accounting_email),
            },
        };
    },

    methods: {
        validate(attribute) {
            return this.formerrors[attribute] ? this.formerrors[attribute][0] : ''
        }
    },

    computed: {
        clientExists() {
            return !!this.client.id;
        },
        radiobuttons() {
            return [
                {
                    'value': 'license_plan_alpha',
                    'title': this.trans('clients.label.license_plan_alpha'),
                    'description': this.trans('clients.text.license_plan_alpha_description'),
                    'status': this.fields.licensePlan == 'license_plan_alpha',
                },
                {
                    'value': 'license_plan_beta',
                    'title': this.trans('clients.label.license_plan_beta'),
                    'description': this.trans('clients.text.license_plan_beta_description'),
                    'status': this.fields.licensePlan == 'license_plan_beta',
                }
            ];
        },
    },

    mounted() {
        EventBus.$on('radiobuttonsChanged', data => {
            if(data.name == 'license_plan') {
                this.fields.licensePlan = data.value;
            }
        });
    },

    watch: {
        fields: {
            handler() {
                this.$emit('bubbleClientLicenseFields', this.fields);
            },
            deep: true,
        },
    }
}
</script>
